import React, { useEffect } from "react";
import { HamburgerIcon } from "../icons/Hamburger.tsx";

import { Link, useLocation } from "react-router-dom";
import { CloseIcon } from "../icons/Close.tsx";

export const Navigation = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const location = useLocation();

  const activeLinkClass = " navigation-menu__link--active";

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  const onClick = (e: React.MouseEvent) => {
    setIsOpen(false);
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="navigation">
      <div
        className={
          "fixed-navigation-bar" + (isOpen ? " fixed-navigation-bar--open" : "")
        }
      >
        <div className="fixed-navigation-bar-title">
          <Link to="/" aria-label="Go to Charproof homepage" onClick={onClick}>
            <span>Charproof</span>
          </Link>
        </div>

        <div className="fixed-navigation-bar-menu">
          <button
            className="fixed-navigation-bar-menu__toggle"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <CloseIcon /> : <HamburgerIcon />}
          </button>
        </div>
      </div>

      <div
        className={"navigation-menu" + (isOpen ? " navigation-menu--open" : "")}
      >
        <div className="navigation-menu__content-wrapper">
          <div className="navigation-menu__links">
            <Link
              className={
                "navigation-menu__link" +
                (location.pathname === "/" ? activeLinkClass : "")
              }
              to="/"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link
              className={
                "navigation-menu__link" +
                (location.pathname === "/finishes" ? activeLinkClass : "")
              }
              to="/finishes"
              onClick={() => setIsOpen(false)}
            >
              Finishes
            </Link>
            <Link
              className={
                "navigation-menu__link" +
                (location.pathname === "/gallery" ? activeLinkClass : "")
              }
              to="/gallery"
              onClick={() => setIsOpen(false)}
            >
              Gallery
            </Link>
            <Link
              className={
                "navigation-menu__link" +
                (location.pathname === "/contact-us" ? activeLinkClass : "")
              }
              to="/contact-us"
              onClick={() => setIsOpen(false)}
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
